import { render } from "./MemberTab.vue?vue&type=template&id=6512869d&scoped=true"
import script from "./MemberTab.vue?vue&type=script&lang=js"
export * from "./MemberTab.vue?vue&type=script&lang=js"

import "./MemberTab.vue?vue&type=style&index=0&id=6512869d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6512869d"]])

export default __exports__